// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tree-selectNumber-box {\n  margin-top: 8px !important;\n  border-top: 1px solid transparent;\n}\n", ""]);
// Exports
module.exports = exports;
